import {
  CLEAR_SEARCH_CUSTOMERS,
  SEARCH_CUSTOMERS,
  SEARCH_CUSTOMERS_FULFILLED,
  SEARCH_CUSTOMERS_REJECTED,
  SearchCustomersState,
  SearchCustomersActionTypes,
} from './types';

const initialState: SearchCustomersState = {
  searchResults: undefined,
  searchValue: '',
  searchCustomersState: {
    isPending: false,
    apiError: undefined,
    validationError: undefined,
  },
};

export function searchCustomersReducer(
  state = initialState,
  action: SearchCustomersActionTypes
): SearchCustomersState {
  switch (action.type) {
    case SEARCH_CUSTOMERS:
      return {
        ...state,
        searchValue: action.payload,
        searchCustomersState: {
          apiError: undefined,
          validationError: undefined,
          isPending: true,
        },
      };

    case SEARCH_CUSTOMERS_FULFILLED:
      return {
        ...state,
        searchResults: action.payload.searchResults,
        searchCustomersState: {
          apiError: undefined,
          validationError: undefined,
          isPending: false,
        },
      };

    case SEARCH_CUSTOMERS_REJECTED:
      return {
        ...state,
        searchCustomersState: {
          apiError: action.payload.apiError,
          validationError: action.payload.validationError,
          isPending: false,
        },
      };

    case CLEAR_SEARCH_CUSTOMERS:
      return initialState;

    default:
      return state;
  }
}
